// extracted by mini-css-extract-plugin
export default {"popup":"OccupationPopup__popup--2Kz","inner":"OccupationPopup__inner--rsE","container":"OccupationPopup__container--91t"};